module.exports = __webpack_public_path__ + "img/alentour6.18e20786.jpg";